import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr } from '../../../../utils/sessionHelpers'
import { getExpenseRequestReport } from '../../../../redux/actions/accountingReport.js'
import DepositReportWidget from '../../../../widgets/depositReport/DepositReportWidget'

export default function Deposit() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getExpenseRequestReport(projectCode)
      // console.log('schemaaaa => ', _schema.model)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <DepositReportWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
